// extracted by mini-css-extract-plugin
module.exports = {"two-column-image-container":"TwoColumnRow_two-column-image-container__Y9Wl9","content":"TwoColumnRow_content__dvBvV"};